module.exports = __webpack_public_path__ + "img/play.e68c166d.svg";